/** Viewer-local ambient fire motion; independent of camera and combat feedback preferences. */
export const FT3D_FIRE_MOTION_STORAGE_KEY = 'ft3d.fireMotion.v1';
export type Ft3dFireMotion = 'animated' | 'system' | 'paused';
let preference: Ft3dFireMotion | undefined;
let media: MediaQueryList | undefined;
const subscribers = new Set<(value: Ft3dFireMotion) => void>();

function normalize(value: unknown): Ft3dFireMotion {
    return value === 'system' || value === 'paused' ? value : 'animated';
}

export function readFt3dFireMotion(): Ft3dFireMotion {
    if (preference === undefined) {
        try { preference = normalize(window.localStorage.getItem(FT3D_FIRE_MOTION_STORAGE_KEY)); }
        catch { preference = 'animated'; }
        window.addEventListener('storage', event => {
            if (event.key !== null && event.key !== FT3D_FIRE_MOTION_STORAGE_KEY) return;
            preference = normalize(event.newValue);
            for (const notify of subscribers) notify(preference);
        });
    }
    return preference;
}

export function writeFt3dFireMotion(value: Ft3dFireMotion): void {
    readFt3dFireMotion();
    preference = normalize(value);
    try { window.localStorage.setItem(FT3D_FIRE_MOTION_STORAGE_KEY, preference); }
    catch { /* The choice remains usable for this window when storage is unavailable. */ }
    for (const notify of subscribers) notify(preference);
}

export function subscribeFt3dFireMotion(notify: (value: Ft3dFireMotion) => void): () => void {
    subscribers.add(notify);
    notify(readFt3dFireMotion());
    return () => { subscribers.delete(notify); };
}

export function ft3dFireMotionEnabled(): boolean {
    const value = readFt3dFireMotion();
    if (value === 'system') {
        media ??= window.matchMedia('(prefers-reduced-motion: reduce)');
        return !media.matches;
    }
    return value === 'animated';
}
